// Auto-generated from WhiskeyBible.csv - The Rusty Nail collection
export const whiskeyCategories = [
  "All",
  "Blended Scotch",
  "Canadian Whisky",
  "Cognac",
  "Corn",
  "Extra",
  "Irish Whiskey",
  "Rum",
  "Rye",
  "Single Malt Scotch",
  "Single Malt Whiskey",
  "Tequila",
  "Wheated",
  "Whiskey",
  "World Whisky"
];

export const whiskeys = [
  {
    "category": "Whiskey",
    "name": "1792/ 12 yr"
  },
  {
    "category": "Whiskey",
    "name": "1792/ Full Proof. 125 proof"
  },
  {
    "category": "Whiskey",
    "name": "1792/ Small Batch. 93.7 proof"
  },
  {
    "category": "Whiskey",
    "name": "291/ Barrel Proof. Single Barrel. 126.6 proof"
  },
  {
    "category": "Whiskey",
    "name": "2XO/ The Phoenix Blend. 104 proof"
  },
  {
    "category": "Whiskey",
    "name": "Amador / Double Barrel. Small Batch.  86 proof"
  },
  {
    "category": "Whiskey",
    "name": "Angels Envy/ Port Wine Barrels. 86.6 proof"
  },
  {
    "category": "Whiskey",
    "name": "Baker’s/ 7 yr.. Single Barrel. 107 proof"
  },
  {
    "category": "Whiskey",
    "name": "Balcones/ TX. Pot Stilled. 92 proof"
  },
  {
    "category": "Whiskey",
    "name": "Balcones/ TX. ZZ Top. Tres Hombres. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bardstown/ Discovery Series No. 3. 110 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bardstown/ Discovery Series. 104.5 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bardstown/ Finished in Founders KBS aged Stout barrels. 110 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bardstown/ Fusion Series No. 3. 98.9 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bardstown/ Fusion Series. 97.9 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bardstown/ Phifer Pavitt Reserve. Cask Strength. Cabernet Sauvignon Barrels."
  },
  {
    "category": "Whiskey",
    "name": "100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bardstown/ Plantation Rum Barrels.104 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bardstown/ The Collaborative Series. Finished in Plantation Rum Barrels. 104"
  },
  {
    "category": "Whiskey",
    "name": "Bardstown/ The Prisoner. French Oak Red Wine Barrels. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Barrell/ 6 yr.. Cask Strength. Batch 29. Bottle No. 6262. 115.88 proof"
  },
  {
    "category": "Whiskey",
    "name": "Barrell/ 9 yr.. Cask Strength. Batch 26. Bottle 2791. 112.64 proof"
  },
  {
    "category": "Whiskey",
    "name": "Barrell/ Armida. Pear Brandy. Rum and Sicilian Amaro Cask. Cask Strength."
  },
  {
    "category": "Whiskey",
    "name": "Bottle No. 4135. 113.54 proof"
  },
  {
    "category": "Whiskey",
    "name": "Barrell/ Dove Tail. Bottle No. 4786. 122.54 proof"
  },
  {
    "category": "Whiskey",
    "name": "Barrell/ Dove Tail. Cask Strength. Finished in Rum. Cabernet Barrels. Bottle No. 1095. 124.7 proof"
  },
  {
    "category": "Whiskey",
    "name": "Barrell/ New Year. 2022. Limited Edition. Bottle No. 14142. 115.34 proof"
  },
  {
    "category": "Whiskey",
    "name": "Barrell/ Vantage. Cask Strength. Finished in Mizunara. French Toasted American oak 114.44 proof"
  },
  {
    "category": "Whiskey",
    "name": "Basil Hayden/ Small Batch. 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bombergers Batch No. 22G2142. 108 proof"
  },
  {
    "category": "Whiskey",
    "name": "Belfour/ Texan Pecan Wood. 92 proof"
  },
  {
    "category": "Whiskey",
    "name": "Belle Meade/ Reserve. 108.3 proof"
  },
  {
    "category": "Whiskey",
    "name": "Belle Meade/ Sherry Cask. 90.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Belle Meade/ Small Batch. Madeira Cask. 90.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Benchmark/ Elevation Matters. Top Floor. 86 proof"
  },
  {
    "category": "Whiskey",
    "name": "Benchmark/ Extra Strong. Full Proof. 125 proof"
  },
  {
    "category": "Whiskey",
    "name": "Benchmark/ Select Cask. Small Batch. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Benchmark/ Single Season. Bonded. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Benjamin Chapman/ 4 yr.. Small Batch. 90 proof ."
  },
  {
    "category": "Whiskey",
    "name": "Bib & Tucker/ 12 yr.. Single Barrel. Bottle 55. Barrel . 99 proof"
  },
  {
    "category": "Whiskey",
    "name": "BIB & Tucker/ 6 yr.. Small Batch. TN. 92 proof"
  },
  {
    "category": "Whiskey",
    "name": "Blackened/ Cask Strength. Limited Edition. Batch 117. TX Edition. Black Brandy Casks. 117 proof"
  },
  {
    "category": "Whiskey",
    "name": "Blade and Bow/ 91 proof"
  },
  {
    "category": "Whiskey",
    "name": "Blanton’s/ Single Barrel. 93 proof"
  },
  {
    "category": "Whiskey",
    "name": "Blood Oath/ Packed No. 7. Very Limited Release. 98.6 proof"
  },
  {
    "category": "Whiskey",
    "name": "Blood Oath/ Packed No. 8. Very Limited Release. Calvados Cask. 98.6 proof"
  },
  {
    "category": "Whiskey",
    "name": "Blue Note/ 17 yr.. Limited Edition. Barrel Proof. ACL Pick. 94.5 proof"
  },
  {
    "category": "Whiskey",
    "name": "Blue Note/ Juke Joint. Uncut. ACL Pick. TN. 119.6 proof"
  },
  {
    "category": "Whiskey",
    "name": "Blue Run/ Reflection 1. Spring 2022. 95 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bluegrass/ Small Batch. Limited Release. Toasted Oak. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bomberger’s/ Declaration. Small Batch. 2021 Release. Bottle 216/1768. 108 Proof"
  },
  {
    "category": "Whiskey",
    "name": "Bomberger’s/ Declaration. Small Batch. 2022 Release. Bottle No.1656/1996."
  },
  {
    "category": "Whiskey",
    "name": "Booker’s/ 7 yr.. The Lumberyard Batch. Batch No. 2022-02. 124.8 proof"
  },
  {
    "category": "Whiskey",
    "name": "Booker’s/ Ronnie’s Batch. 6 yrs. 11 mo. 22 days. Batch 2022-01. 124.3 proof"
  },
  {
    "category": "Whiskey",
    "name": "Breaker/ Limited Release. California. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Breckenridge/ Port Cask Finish. Batch 13. Colorado. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Brother’s Bond/ Hand Selected Batch. Distilled in Indiana. 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Brush Creek / Honig. Cabernet Cask Finish. 97.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Buffalo Trace/ 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bulleit/ 10 yr.. Small Batch. 91.2 proof"
  },
  {
    "category": "Whiskey",
    "name": "Bulleit/ 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Calumet Farm/ 14 yr.. Barrel. March 2006. 96.2 proof"
  },
  {
    "category": "Whiskey",
    "name": "Calumet Farm/ Citation. 16 yr.. 106 proof"
  },
  {
    "category": "Whiskey",
    "name": "Calumet Farm/ Small Batch. 15 yr. & 8 yr. Blend. 86 proof"
  },
  {
    "category": "Whiskey",
    "name": "Calumet Farm/ Whirlaway. 15 yr.. 105 proof"
  },
  {
    "category": "Whiskey",
    "name": "Cascade Moon/ Barrel Proof. 15 yr.. 79.8 proof"
  },
  {
    "category": "Whiskey",
    "name": "Casey Jones/ Barrel Cut. Single Barrel. Small Batch. 104.8 proof"
  },
  {
    "category": "Whiskey",
    "name": "Casey Jones/ Small Batch. 2.8 yr.. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Casey Jones/ Small Batch. 2.9 yr.. 112 proof"
  },
  {
    "category": "Whiskey",
    "name": "Castle & Key/ Small Batch. 2022. 97 proof"
  },
  {
    "category": "Whiskey",
    "name": "Castle & Key/ Small Batch. Batch 5. 2022. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Chattanooga/ Barrel Finished Series. Islay. Scotch Cask. 95 proof"
  },
  {
    "category": "Whiskey",
    "name": "Chattanooga/ Single Barrel. Barrel 91. 118.2 proof"
  },
  {
    "category": "Whiskey",
    "name": "Chattanooga/ Single Barrel. Peated. 123 proof"
  },
  {
    "category": "Whiskey",
    "name": "Chicken Cock/ 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Clyde May’s/ Special Reserve. 5 yr.. 110 proof"
  },
  {
    "category": "Whiskey",
    "name": "Colonel E.H. Taylor/ Single Barrel. BIB. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Coppercraft/ Small Batch. Blend. Michigan. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Coppercraft/ Small Batch. Straight. 97 proof"
  },
  {
    "category": "Whiskey",
    "name": "Cream of Kentucky/ 12.3 yrs.. Batch No. 3. 102 proof"
  },
  {
    "category": "Whiskey",
    "name": "Critical Batch/ Single Barrel. TX. 110 proof"
  },
  {
    "category": "Whiskey",
    "name": "Daviess / Daviess County. Double Barrel. Limited Edition. Small Batch. 96"
  },
  {
    "category": "Whiskey",
    "name": "proofDoc Swinson’s/ 15 yr.. Exploratory Cask Series. Cask Strength. 109.8 Proof"
  },
  {
    "category": "Whiskey",
    "name": "Doc Swinson’s/ Alter Ego. Triple Cask. Sherry & Cognac Cask. Small Batch. 95.8 Proof"
  },
  {
    "category": "Whiskey",
    "name": "Eagle Rare/ 10 yr.. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Early Times/ 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Eight & Sand/ Indiana. 88 proof"
  },
  {
    "category": "Whiskey",
    "name": "Elijah Craig/ 18 yr.. Single Barrel. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Elijah Craig/ 8 yr.. Private. Single Barrel. ACL Pick. 130.7 proof"
  },
  {
    "category": "Whiskey",
    "name": "Elijah Craig/ Barrel Proof. 12 yrs.. 123.6 proof"
  },
  {
    "category": "Whiskey",
    "name": "Elijah Craig/ Barrel Proof. 121 proof"
  },
  {
    "category": "Whiskey",
    "name": "Elijah Craig/ Small Batch. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Elijah Craig/ Toasted Barrel. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Elmer T. Lee/ Single Barrel. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Elvis/ Tiger Man. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Evan Williams/ 86 proof"
  },
  {
    "category": "Whiskey",
    "name": "Evan Williams/ Single Barrel Vintage. 86.6 proof"
  },
  {
    "category": "Whiskey",
    "name": "Few/ 93 proof"
  },
  {
    "category": "Whiskey",
    "name": "Few/ Single Barrel. BIB. ACL Pick. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Fighting Cock/ 103 proof"
  },
  {
    "category": "Whiskey",
    "name": "Fistful of Bourbon/ Five Blend. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Flying Ace/ 84 proof"
  },
  {
    "category": "Whiskey",
    "name": "Four Gate/ The Kelvin Collaboration IIII.  111.7 Proof"
  },
  {
    "category": "Whiskey",
    "name": "Four Roses/ 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Four Roses/ Single Barrel. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Four Roses/ Small Batch Select. 104 proof"
  },
  {
    "category": "Whiskey",
    "name": "Four Roses/ Small Batch. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Garage Oil/ 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Garrison Brothers/ Balmorhea. TX. 115 proof"
  },
  {
    "category": "Whiskey",
    "name": "Garrison Brothers/ Cowboy Bourbon. 2021. Autographed. 131.3 proof"
  },
  {
    "category": "Whiskey",
    "name": "Garrison Brothers/ Guadalupe. 2022. TX. 107 proof"
  },
  {
    "category": "Whiskey",
    "name": "Garrison Brothers/ Honey Dew. 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Garrison Brothers/ Laguna Madre. 2021. TX. 101 proof"
  },
  {
    "category": "Whiskey",
    "name": "Garrison Brothers/ Single Barrel. TX. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Garrison Brothers/ Small Batch. TX. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Gentleman Jack/ 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "George Dickel/ 17 yr.. Cask Strength Reserve. 92 proof"
  },
  {
    "category": "Whiskey",
    "name": "George Dickel/ Barrel Select. Small Batch. 86 proof"
  },
  {
    "category": "Whiskey",
    "name": "George Dickel/ BIB. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "George Dickel/ Single Barrel. 15 yr.. Bottle 119"
  },
  {
    "category": "Whiskey",
    "name": "Goodwood / Honey Ale Barrel Finish. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Hancock’s/ President’s Reserve. 88.9 proof"
  },
  {
    "category": "Whiskey",
    "name": "Hardin’s Creek / *James B. Bean 2 yr.. 108 proof"
  },
  {
    "category": "Whiskey",
    "name": "Heaven Hill/ BIB. 7 yr.. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Heaven Hill/ Quality House. 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Heaven’s Door/ 10 yr.. Decade Series. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Heaven’s Door/ 90 proofHeaven’s Door/ Redbreast. Irish Whiskey Cask. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Heaven’s Door/ The Bootleg Series. Vol. III. 13 yr.. 2021. Cask Strength."
  },
  {
    "category": "Whiskey",
    "name": "Vino de la Naranja Cask. 121.1 proof"
  },
  {
    "category": "Whiskey",
    "name": "Heaven’s Door/ The Bootleg Series. Vol. IV. 11 yr.. Wheated. Islay Scotch"
  },
  {
    "category": "Whiskey",
    "name": "Cask. 2022. 111.16 proof"
  },
  {
    "category": "Whiskey",
    "name": "Henry McKenna/ 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Henry McKenna/ Single Barrel. 10 yr. BIB. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Herman Marshall’s/ Dry County. TX. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Herman Marshall’s/ Texas Blend Port Finished. TX. 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "High West/ American Prairie. Barrel Select. Utah. 96.6 proof"
  },
  {
    "category": "Whiskey",
    "name": "Hirsch/ The Bivouac. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Hirsch/ The Horizon. 92 proof"
  },
  {
    "category": "Whiskey",
    "name": "Hooten Young/ OH. 12 yr.. Barrel proof. Bottle 1722/3000. 120 proof"
  },
  {
    "category": "Whiskey",
    "name": "Horse Soldier/ Autographed. OH. 87 proof"
  },
  {
    "category": "Whiskey",
    "name": "Horse Soldier/ Barrel Strength. 112.44 proof"
  },
  {
    "category": "Whiskey",
    "name": "Ironroot Republic/ Esoteric. 97 proof"
  },
  {
    "category": "Whiskey",
    "name": "Ironroot Republic/ Promethean. TX. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Isaac Bowman/ Pioneer Spirit. Small Batch. Port Barrel. 92 proof"
  },
  {
    "category": "Whiskey",
    "name": "J.H. Cutter/ A.NO.1.. Whisky. 96 proof"
  },
  {
    "category": "Whiskey",
    "name": "Jack Daniel’s/ Bonded. BIB. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Jack Daniel’s/ No. 27 Gold. Maple Wood. 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Jack Daniel’s/ Sinatra Select. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Jack Daniel’s/ Single Barrel Select. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Jack Daniel’s/ Single Barrel. Barrel Proof. 131.9 proof"
  },
  {
    "category": "Whiskey",
    "name": "Jack Daniel’s/ Triple Mash. Blend. BIB. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Jefferson’s Ocean/ Aged at Sea. Very Small Batch. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Jefferson’s Reserve/ Pritchard Hill. Cabernet Cask. 90.2 proof"
  },
  {
    "category": "Whiskey",
    "name": "Jefferson’s Reserve/ Very Old Very Small Batch. 90.2 proof"
  },
  {
    "category": "Whiskey",
    "name": "Jeppson’s/ Chicago. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Jim Beam/ 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Jim Beam/ Single Barrel. Selective Batch. 108 proof"
  },
  {
    "category": "Whiskey",
    "name": "John B. Stetson/ Legendary hats since 1865. California. 84 proof"
  },
  {
    "category": "Whiskey",
    "name": "Johnny Drum/ Private Stock. 101 proof"
  },
  {
    "category": "Whiskey",
    "name": "Joseph Maguns/ Sherry & Cognac Cask.  100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Kentucky Owl/ Confiscated. 96.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Kentucky Owl/ Limited Release. Takumi Edition. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Kentucky Owl/ St. Patrick’s Edition. Limited Release"
  },
  {
    "category": "Whiskey",
    "name": "Kentucky Owl/ The Wiseman. 90.8 proof"
  },
  {
    "category": "Whiskey",
    "name": "Kings County/ Barrel Strength. NY. 127.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Kings County/ NY. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Knob Creek/ 12 yr.. Small Batch. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Knob Creek/ 9yr.. Small Batch. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Knob Creek/ Limited Edition. Small Batch. 15 yr.. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Knob Creek/ Limited Edition. Small Batch. 18 yr.. 2022. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Koval/ Single Barrel. Chicago. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Larceny/ Barrel Proof. 122.6 proof"
  },
  {
    "category": "Whiskey",
    "name": "Laws Whiskey House/ Cask Strength. Single Barrel. ACL Pick. Barrel No. 1233."
  },
  {
    "category": "Whiskey",
    "name": "Whiskey House/ Four Grain Cask. ACL pick. Colorado. 122.94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Laws Whiskey House/ Four Grain. Batch 21. 95 proof"
  },
  {
    "category": "Whiskey",
    "name": "Legendary Duke/ Grand Cru Founders Reserve. Finished in Grand Cru French 110 proof"
  },
  {
    "category": "Whiskey",
    "name": "Legent/ Wine & Sherry Casks. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Little Book/ 2021. 116.8 proof"
  },
  {
    "category": "Whiskey",
    "name": "Little Book/ 2022. 117.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Lost Republic/ Small Batch. California. 91 proof"
  },
  {
    "category": "Whiskey",
    "name": "Luckenback Road Whiskey/ 3 yr.. Light. Small Batch. 88 proof"
  },
  {
    "category": "Whiskey",
    "name": "Lusty Claw/ 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Maker’s Mark/ 46. Frenched Oaked. French Oak Staves. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Maker’s Mark/ 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Maker’s Mark/ Cask Strength. 110.8 proof"
  },
  {
    "category": "Whiskey",
    "name": "Maker’s Mark/ Limited Release. 101 proof"
  },
  {
    "category": "Whiskey",
    "name": "Maker’s Mark/ Private Selection. D’yer Mak’er. ACL Pick. Finished with 10"
  },
  {
    "category": "Whiskey",
    "name": "Selected Oak Staves. October 2021. 111.8 proof"
  },
  {
    "category": "Whiskey",
    "name": "Maker’s Mark/ Private Selection. Fool in the Rain. Finished with 10 Selective"
  },
  {
    "category": "Whiskey",
    "name": "Maker’s Mark/ Wood Finishing Series. 2022 Limited Edition. BRT-02. Finished"
  },
  {
    "category": "Whiskey",
    "name": "Maker’s Mark/ Wood Finishing Series. 2022 Limited Release. BRT-01. 10 Virgin"
  },
  {
    "category": "Whiskey",
    "name": "Merica/TX. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Michter’s/ Limited Release. Toasted Barrel. Batch No. 22. G 2258. 86 proof"
  },
  {
    "category": "Whiskey",
    "name": "Michter’s/ Small Batch. 91.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Michter’s/ Small Batch. Unblended. 83.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Middle West/ Double Cask Collection. 6 yr.. Sherry Cask. Batch 2. Ohio. 97.25 proof"
  },
  {
    "category": "Whiskey",
    "name": "Milam & Greene/ Triple Cask. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Milam & Greene/ Unabridged. Cask Strength. 118.3 proof"
  },
  {
    "category": "Whiskey",
    "name": "Milam & Greene/ Very Small Batch. Distillery Edition. 121.8 proof"
  },
  {
    "category": "Whiskey",
    "name": "Nashville Barrel Co./ Custom Batch for Texas. Cask Strength. TN. 114.62 proof"
  },
  {
    "category": "Whiskey",
    "name": "Nelson Bros./ Reserve. 107.8 proof"
  },
  {
    "category": "Whiskey",
    "name": "Nelson’s/ “Green Brier”. 91 proof"
  },
  {
    "category": "Whiskey",
    "name": "Noah’s Mill/ Small Batch. 114.3 proof"
  },
  {
    "category": "Whiskey",
    "name": "Noble Oak/ Double Oak. Finished w/Sherry Oak Staves. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Nulu/ Toasted Small Batch. TX. Exclusive. 121.2 proof"
  },
  {
    "category": "Whiskey",
    "name": "Oak & Eden/ American Oak. ACL Pick. 116 proof"
  },
  {
    "category": "Whiskey",
    "name": "Oak & Eden/ Toasted Oak. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Old Elk/ Infinity Blend. 2021. 114.9 proof"
  },
  {
    "category": "Whiskey",
    "name": "Old Ezra / 7 yr.. Barrel strength 117 proof"
  },
  {
    "category": "Whiskey",
    "name": "Old Forester/ 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Old Forester/ 1910. Old Fine Whiskey. 93 proof"
  },
  {
    "category": "Whiskey",
    "name": "Old Forester/ 1920 Prohibition Style. 115 proof"
  },
  {
    "category": "Whiskey",
    "name": "Old Forester/ 86 proof"
  },
  {
    "category": "Whiskey",
    "name": "Old Forester/ King Ranch. 105 Proof"
  },
  {
    "category": "Whiskey",
    "name": "Old Forester/ Single Barrel. Barrel Strength. WHSE.G Floor 6. 128.1 proof"
  },
  {
    "category": "Whiskey",
    "name": "Old Forester/ Statesman. 95 proof"
  },
  {
    "category": "Whiskey",
    "name": "Old Grand-Dad/ High Rye Mash Bill. 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Old Settler/ Camp No. 1 Blend. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Old Tub/ BIB. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "ORPHaN BARREL/ 14 yr.. Fable & Folly. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Outryder/ BIB. WY. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Peerless/ Double Oak. 107.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Peerless/ Small Batch. 107.5 proof"
  },
  {
    "category": "Whiskey",
    "name": "Peerless/ Small Batch. 109.2 proof"
  },
  {
    "category": "Whiskey",
    "name": "Penelope/ American Light. 13 yr.. Founders Reserve. 128.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Penelope/ Barrel Strength. Private Select. ACL Pick. 115 proof"
  },
  {
    "category": "Whiskey",
    "name": "Penelope/ Barrel Strength. Texas Select. Toasted Series. 114.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Penelope/ Barrel Strength. Toasted Series. ACL Pick. 115 proof"
  },
  {
    "category": "Whiskey",
    "name": "Penelope/ Four Grain. 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Penelope/ Rose Cask Finish. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Pin Hook/ 4 yr.. Bourbon War. 16.0 Hands. 98 proof"
  },
  {
    "category": "Whiskey",
    "name": "Pursuit/ United. 108 proof"
  },
  {
    "category": "Whiskey",
    "name": "Rabbit Hole/ Cavehill. Four Grain. Small Batch. 95 proof"
  },
  {
    "category": "Whiskey",
    "name": "Rabbit Hole/ Dareringer. Small Batch. Finished in PX Sherry Cask. 93 proof"
  },
  {
    "category": "Whiskey",
    "name": "Rabbit Hole/ Founder’s Collection. 15 yr.. Mizunara Cask. 114.2 proof"
  },
  {
    "category": "Whiskey",
    "name": "Rabbit Hole/ Heigold. Small Batch. High Rye. 95 proof"
  },
  {
    "category": "Whiskey",
    "name": "Ragged Branch/ BIB. Batch 5. Bottle 1312. VA. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Ragged Branch/ Signature. Batch 19. Bottle 1513. VA. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Ranch Heritage/ 4 yr.. Bonded Strength. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Ranch Regulator/ 8 yr.. 120 proof"
  },
  {
    "category": "Whiskey",
    "name": "Ranger Creek/ .36. 96 proof"
  },
  {
    "category": "Whiskey",
    "name": "Ranger Creek/ .36. Cask Strength. 125.2 proof"
  },
  {
    "category": "Whiskey",
    "name": "Ransom / 88 proof"
  },
  {
    "category": "Whiskey",
    "name": "Rebecca Creek/ 12 yr.. Cask Strength. 99.68 proof"
  },
  {
    "category": "Whiskey",
    "name": "Rebecca Creek/ Blend. TX. 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Rebel/ 10 yr.. Single Barrel. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Red Wood Empire/ Pipe Dream. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Redemption/ 88 proof"
  },
  {
    "category": "Whiskey",
    "name": "Redemption/ 9 yr.. Barrel Proof. 103.9 proof"
  },
  {
    "category": "Whiskey",
    "name": "Redemption/ Rum Cask Finish. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Remus/ Gatsby Reserve. 15 yr.. 2022 Limited Edition Release. Cask Strength. 97.8 proof"
  },
  {
    "category": "Whiskey",
    "name": "Remus/ Repeal Reserve. 2020 Medley. IV. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Responder Bourbon/ 10-41. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Rock Hill Farms/ Single Barrel. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Rowan’s Creek/ Small Batch. 100.1 proof"
  },
  {
    "category": "Whiskey",
    "name": "Russel’s Reserve/ 10 yr.. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Sam Houston/ 15 yr.. Batch No. TX-2. 3 Barrels. 2021. 418/522. 103 proof"
  },
  {
    "category": "Whiskey",
    "name": "Samuel Maverick/ 88 proof"
  },
  {
    "category": "Whiskey",
    "name": "Samuel Maverick/ Barrel proof. 114 proof"
  },
  {
    "category": "Whiskey",
    "name": "Seagram’s 7/ 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Slaughter House/ California. 88 proof"
  },
  {
    "category": "Whiskey",
    "name": "Smoke Wagon/ Las Vegas. 92.5 proof"
  },
  {
    "category": "Whiskey",
    "name": "Smoke Wagon/ Red. White and Blue Edition. Las Vegas. 92.5 proof"
  },
  {
    "category": "Whiskey",
    "name": "Smoke Wagon/ Small Batch. Las Vegas. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Smoke Wagon/ Uncut the Younger. Las Vegas. 113.7 proof"
  },
  {
    "category": "Whiskey",
    "name": "Smoke Wagon/ Uncut. Unfiltered. Las Vegas. 113.16 proof"
  },
  {
    "category": "Whiskey",
    "name": "Smooth Ambler/ Contradiction. 92 proof"
  },
  {
    "category": "Whiskey",
    "name": "St. Cloud/ 7 yr.. Barrel Name: Magic 32. 125 proof"
  },
  {
    "category": "Whiskey",
    "name": "St. Cloud/ Barrel Name: Go Mavs. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Stagg Jr./ Barrel Proof. 128.7 proof"
  },
  {
    "category": "Whiskey",
    "name": "Stagg Jr./ Barrel Proof. 131.1 proof"
  },
  {
    "category": "Whiskey",
    "name": "Stellum/ Cask Strength. 109.22 proof"
  },
  {
    "category": "Whiskey",
    "name": "Stellum/ Cask Strength. 114.98 proof"
  },
  {
    "category": "Whiskey",
    "name": "Still Austin/ Limited Release. Single Barrel. Cask Strength. TX. 116 proof"
  },
  {
    "category": "Whiskey",
    "name": "Stillhouse/ Black Bourbon. Mellowed in coffee beans. 80 proof"
  },
  {
    "category": "Whiskey",
    "name": "Straight Edge/ California. 84 proof"
  },
  {
    "category": "Whiskey",
    "name": "Sweetens Cove/ Kennessee. Toasted Sugar Maple Wood. 110.7 proof"
  },
  {
    "category": "Whiskey",
    "name": "Sweetens Cove/ Tennessee. Cask Strength. 2021. 113.7 proof"
  },
  {
    "category": "Whiskey",
    "name": "The Burning Chair/ CA. 88 proof"
  },
  {
    "category": "Whiskey",
    "name": "The Clover/ Single Barrel. 10 year. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Tin Cup/ 84 proof"
  },
  {
    "category": "Whiskey",
    "name": "Tom’s Town/ Double Oaked. MI. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Town Branch/ 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Town Branch/ True Cask. Small Batch. 108.1 proof"
  },
  {
    "category": "Whiskey",
    "name": "TX/ Blended. 82 proof"
  },
  {
    "category": "Whiskey",
    "name": "TX/ Straight. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Uncle Nearest/ 1856. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Uncle Nearest/ 1884 Small Batch. 93 proof"
  },
  {
    "category": "Whiskey",
    "name": "Very Old Barton/ 86 proof"
  },
  {
    "category": "Whiskey",
    "name": "Virginia Distillery Co./ Cider Cask. Batch 8. VA. 92 proof"
  },
  {
    "category": "Whiskey",
    "name": "Virginia Distillery Co./ Coffee Cask. TX Select. VA. 92 proof"
  },
  {
    "category": "Whiskey",
    "name": "Virginia Distillery Co./ Port Cask. VA. 92 proof"
  },
  {
    "category": "Whiskey",
    "name": "Walking Stick/ Single Barrel. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Wathen’s/ Single Barrel. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Wattie Boone & Sons/ Small Batch. 7 yr. Ancient Reserve. 94.7 proof"
  },
  {
    "category": "Whiskey",
    "name": "Whiskey Smith/ Small Batch. TX. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Whitmeyers/ Texas Single Barrel. Cask Strength. 112 proof"
  },
  {
    "category": "Whiskey",
    "name": "Widow Jane/ 10 yr.. NY. 91 proof"
  },
  {
    "category": "Whiskey",
    "name": "Widow Jane/ 12 yr.. Single Barrel. ACL Pick. Barrel No. 1965. Bottle 80."
  },
  {
    "category": "Whiskey",
    "name": "2019. NY. 99 proof"
  },
  {
    "category": "Whiskey",
    "name": "Widow Jane/ Decadence. Finished in maple syrup barrels. NY. 91 proof"
  },
  {
    "category": "Whiskey",
    "name": "Widow Jane/ Lucky 13. Batch 3. Bottle 25. 2022. NY. 93 proof"
  },
  {
    "category": "Whiskey",
    "name": "Widow Jane/ Oak & Apple Wood Aged. Batch 38. Bottle 337. NY. 91 proof"
  },
  {
    "category": "Whiskey",
    "name": "Widow Jane/ The Vaults. 15 yr.. 2021. Batch 2. Bottle 2518. NY. 99 proof"
  },
  {
    "category": "Whiskey",
    "name": "Widow Jane/ The Vaults. 15 yr.. Batch 2. Bottle 2516. 99 proof"
  },
  {
    "category": "Whiskey",
    "name": "Wild Turkey/ 101. 101 proofWild Turkey/ Longbranch. Matthew McConaughey. 86 proof"
  },
  {
    "category": "Whiskey",
    "name": "Wild Turkey/ Master’s Key. Toasted Oak. ONE. Batch 1. Rickhouse G. 101 proof"
  },
  {
    "category": "Whiskey",
    "name": "Wild Turkey/ Master’s Key. Unforgotten. 105 proof"
  },
  {
    "category": "Whiskey",
    "name": "Wild Turkey/ Rare Breed. Barrel Proof. 116.8 proof"
  },
  {
    "category": "Whiskey",
    "name": "Wilderness Trail/ Small Batch. BIB. 100 proof"
  },
  {
    "category": "Whiskey",
    "name": "Willett/ Pot Still Reserved. 94 proof"
  },
  {
    "category": "Whiskey",
    "name": "Woodford Reserve/ 90.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Woodford Reserve/ Double Oaked. 90.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Woodford Reserve/ Master’s Collection. Batch Proof. 118.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Woodford Reserve/ Master’s Collection. Five-Malt Stouted Mash. LTD. Series"
  },
  {
    "category": "Whiskey",
    "name": "Woody Creek/ Small Batch. Colorado Bourbon"
  },
  {
    "category": "Whiskey",
    "name": "Yellow Bird/ 4 yr.. 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Yellowstone/ Landmark Edition. 93 proof"
  },
  {
    "category": "Whiskey",
    "name": "Yellowstone/ Limited Edition. 2022. Bottle No. 21844. 101 proof"
  },
  {
    "category": "Whiskey",
    "name": "ZZ Top Tres Hombres / Batch No. Coupe #1. 94 proof"
  },
  {
    "category": "Rye",
    "name": "291/ Small Batch. Aspen Wood Staves. Colorado. 101.7 proof"
  },
  {
    "category": "Rye",
    "name": "Angels Envy/ Caribbean Rum Casks. 100 proof"
  },
  {
    "category": "Rye",
    "name": "Balcones/ Texas. 100 proof"
  },
  {
    "category": "Rye",
    "name": "Barrell/ 4 yr.. Cask Strength. Batch 003. 116.7 proof"
  },
  {
    "category": "Rye",
    "name": "Barrell/ Seagrass. Finished in Martinque Rum. Madeira & Apricot Brandy"
  },
  {
    "category": "Rye",
    "name": "Barrels. Bottle No. 3620. 128.12 proof"
  },
  {
    "category": "Rye",
    "name": "Blackened/ Double Cask. Finished in Madeira and Rum Casks. 100 proof"
  },
  {
    "category": "Rye",
    "name": "Blackened/ Willett. Limited Edition. Cask Strength. Madeira. 109.6 proof"
  },
  {
    "category": "Rye",
    "name": "Blue Run/ Golden. Summer 2022. 95 proof"
  },
  {
    "category": "Rye",
    "name": "Blue Run/ High Rye. Spring 2022. 111 proof"
  },
  {
    "category": "Rye",
    "name": "Buffalo Trace/ Kosher. 94 proof"
  },
  {
    "category": "Rye",
    "name": "Bulleit 95/ 90 proof"
  },
  {
    "category": "Rye",
    "name": "Cascade Moon/ 13 yr.. Rare Aged. 100 proof"
  },
  {
    "category": "Rye",
    "name": "Casey Jones/ Single Barrel. 3.4 yrs.. 103 proof"
  },
  {
    "category": "Rye",
    "name": "Castle & Key/ Restoration. 2021. 101 proof"
  },
  {
    "category": "Rye",
    "name": "Catoctin Creek/ Ragnarok. Batch 2022. Virginia. GWAR. 92 proof"
  },
  {
    "category": "Rye",
    "name": "Chicken Cock/ 90 proof"
  },
  {
    "category": "Rye",
    "name": "Chicken Cock/ Island Rooster. Rum Barrel. 25 Barrel Batch. 95 proof"
  },
  {
    "category": "Rye",
    "name": "Copper House/ Adnams Southwold. Rye Malt. 5 yr.. England. 94 proof"
  },
  {
    "category": "Rye",
    "name": "Coppercraft/ Small Batch. Michigan. 90 proof"
  },
  {
    "category": "Rye",
    "name": "Doc Swinson’s/ Alter Ego. Solera Method. Small Batch. Rum Casks. 95 proof"
  },
  {
    "category": "Rye",
    "name": "Elijah Craig/ 94 proof"
  },
  {
    "category": "Rye",
    "name": "Elvis/ The King. 90 proof"
  },
  {
    "category": "Rye",
    "name": "Ezra Brooks/ 2 yr.. 90 proof"
  },
  {
    "category": "Rye",
    "name": "George Dickel/ 90 proof"
  },
  {
    "category": "Rye",
    "name": "Herman Marshall/ Small Batch Texas Rye. 102 proofHigh N’ Wicked/ 5 yr.. 90 proof"
  },
  {
    "category": "Rye",
    "name": "High West/ A Winter Nights Dram. Limited Engagement. ACT 10 Scene 6. Port"
  },
  {
    "category": "Rye",
    "name": "Barrel Finished. 98.6 proof"
  },
  {
    "category": "Rye",
    "name": "High West/ Double Rye. Barrel Select. Utah. 101.2 proof"
  },
  {
    "category": "Rye",
    "name": "High West/ Double Rye. Batch No. 21D06. Utah. 92 proof"
  },
  {
    "category": "Rye",
    "name": "Jack Daniel’s/ Single Barrel. 94 proof"
  },
  {
    "category": "Rye",
    "name": "Kentucky Owl/ 10 yr.. Small Batch. Batch 3. 114 proof"
  },
  {
    "category": "Rye",
    "name": "Laws/ 6yr.. San Luis Valley. Bonded. Batch 1. 100 proof"
  },
  {
    "category": "Rye",
    "name": "Leopold Bros/ 2021. BIB. Three Chamber. 100 proof"
  },
  {
    "category": "Rye",
    "name": "Lock Stock & Barrel/ 18 yr.. 109 proof"
  },
  {
    "category": "Rye",
    "name": "Lock Stock & Barrel/ 20 yr.. Private Selection Very Limited Release. 112 proof"
  },
  {
    "category": "Rye",
    "name": "Michter’s/ Single Barrel. 10 yr.. 92.8 proof"
  },
  {
    "category": "Rye",
    "name": "Michter’s/ Single Barrel. 84.8 proof"
  },
  {
    "category": "Rye",
    "name": "Middle West Spirits/ 5 yr.. Ported Pumpernickel. Double Barrel. Aged in"
  },
  {
    "category": "Rye",
    "name": "French Tawny Port Casks. 99.5 proof"
  },
  {
    "category": "Rye",
    "name": "Midway/ Colonel Francisco. 4 yr.. Rum Barrels. Batch 4. Bottle 33. 110 proof"
  },
  {
    "category": "Rye",
    "name": "Milam & Green/ TX. Port Wine Cask. 94 proof"
  },
  {
    "category": "Rye",
    "name": "Minor Case/ Sherry Cask Finished. 90 proof"
  },
  {
    "category": "Rye",
    "name": "Nashville Barrel Co./ Small Batch. Batch 2. A Duet of Ryes. 100 proof"
  },
  {
    "category": "Rye",
    "name": "Nashville Barrel Co./ Texas. Cask Strength. 116.7 proof"
  },
  {
    "category": "Rye",
    "name": "Noble Oak/ Double Oak. Finished with Port Wine Oak Staves. 96 proof"
  },
  {
    "category": "Rye",
    "name": "Nulu/ Toasted. TX Exclusive. 117.6 proof"
  },
  {
    "category": "Rye",
    "name": "Oak & Eden/ Charred Oak. 90 proof"
  },
  {
    "category": "Rye",
    "name": "Old Forester/ 100 proof"
  },
  {
    "category": "Rye",
    "name": "Old Forester/ Single Barrel. Barrel Strength. WHSE.. G Floor 3. 128.4 proof"
  },
  {
    "category": "Rye",
    "name": "Old Overholt/ 86 proof"
  },
  {
    "category": "Rye",
    "name": "Old Potrero/ Single Malt. California. 97 proof"
  },
  {
    "category": "Rye",
    "name": "Peerless/ Small Batch. 109.6 proof"
  },
  {
    "category": "Rye",
    "name": "Penelope/ Tokaji Cask Finished. 6 yr.. Coopers Series. 107 proof"
  },
  {
    "category": "Rye",
    "name": "Pin Hook/ Rye’d On. 16.3 Hands. 97 proof"
  },
  {
    "category": "Rye",
    "name": "Pursuit United./ Small Batch. 108 proof"
  },
  {
    "category": "Rye",
    "name": "Ragged Branch/ BIB. Batch 3. Bottle 451. VA. 100 proof"
  },
  {
    "category": "Rye",
    "name": "Ranger Creek/ .44 Texas. 94 proof"
  },
  {
    "category": "Rye",
    "name": "Rebel Yell/ 90 proof"
  },
  {
    "category": "Rye",
    "name": "Redemption Rye/ 92 proof"
  },
  {
    "category": "Rye",
    "name": "Redemption/ 10 yr.. Barrel Proof. High Rye. 114.4 proof"
  },
  {
    "category": "Rye",
    "name": "Reservoir/ 2022. Batch 1. Bottle 190. Virginia. 96 proof"
  },
  {
    "category": "Rye",
    "name": "Rittenhouse/ BIB. 100 proof"
  },
  {
    "category": "Rye",
    "name": "Sagamore Spirit/ American Whiskey. 83 proof"
  },
  {
    "category": "Rye",
    "name": "Sagamore Spirit/ Cask Strength. 112.2 proof"
  },
  {
    "category": "Rye",
    "name": "Sagamore Spirit/ Double Oak. 96.6 proof"
  },
  {
    "category": "Rye",
    "name": "Sagamore Spirit/ Reserve Series. Rum Cask. 98 proof"
  },
  {
    "category": "Rye",
    "name": "Sagamore Spirit/ Reserve Series. Sherry Barrels. 106 proof"
  },
  {
    "category": "Rye",
    "name": "Saint Liberty/ Josephine’s Flat Head River. Bootleggers Collection Chapter"
  },
  {
    "category": "Rye",
    "name": "Smoke Wagon/ BIB. Las Vegas. 100 proof"
  },
  {
    "category": "Rye",
    "name": "Smoke Wagon/ Malted Rye. Batch 26. Las Vegas. 119.54 proof"
  },
  {
    "category": "Rye",
    "name": "Smooth Ambler/ Old Scout. 4 yr.. Single Barrel. Cask Strength. 119.4 proof"
  },
  {
    "category": "Rye",
    "name": "Templeton/ 4yr.. 80 proof"
  },
  {
    "category": "Rye",
    "name": "Templeton/ 6 yr.. 91.5 proof"
  },
  {
    "category": "Rye",
    "name": "Templeton/ Single Barrel. 10 yr. Reserve. 104 proof"
  },
  {
    "category": "Rye",
    "name": "The Prideful Goat/ 15 yr.. Cask Strength. 114.1 proof"
  },
  {
    "category": "Rye",
    "name": "The Senator/ 6 yr.. Barrel Proof. 2021. 114.8 proof"
  },
  {
    "category": "Rye",
    "name": "Very Olde St. Nick/ Ancient Cask 8 yr.. 82.8 proof"
  },
  {
    "category": "Rye",
    "name": "WhistlePig/ 10 yr.. Small Batch Rye. 100 proof"
  },
  {
    "category": "Rye",
    "name": "WhistlePig/ 12 yr.. Old World Rye. Wine Cask Finish. 86 proof"
  },
  {
    "category": "Rye",
    "name": "WhistlePig/ Estate Oak Rye. Single Barrel. 15 yr.. 92 proof"
  },
  {
    "category": "Rye",
    "name": "WhistlePig/ Estate Oak Rye. Single Barrel. 15 yr.. ACL Pick. 113.6 proof"
  },
  {
    "category": "Rye",
    "name": "WhistlePig/ Farm Stock Rye. Beyond Bonded. 100.1 proof"
  },
  {
    "category": "Rye",
    "name": "WhistlePig/ PiggyBack. 6 yr.. 96.56 proof"
  },
  {
    "category": "Rye",
    "name": "WhistlePig/ PiggyBack. 6 yr.. Legends Series. Brothers Osborne. Small Batch."
  },
  {
    "category": "Rye",
    "name": "Single Barrel. 96.56 proof"
  },
  {
    "category": "Rye",
    "name": "WhistlePig/ Small Batch Rye. 10 yr.. 100 proof"
  },
  {
    "category": "Rye",
    "name": "WhistlePig/ Smoked Stock. Limited Edition. Traeger Woodfire Barrels. 86 proof"
  },
  {
    "category": "Rye",
    "name": "WhistlePig/ The Boss Hog IX. Siren’s Song. Barrel 79. Greek Fig Nectar &"
  },
  {
    "category": "Rye",
    "name": "Scratch Tentura Barrels. 102.5 proof"
  },
  {
    "category": "Rye",
    "name": "WhistlePig/ The Boss Hog VII. Rye. 17 yr.. Magellan’s Atlantic. Barrel 47."
  },
  {
    "category": "Rye",
    "name": "105.8 proof"
  },
  {
    "category": "Rye",
    "name": "WhistlePig/ The Boss Hog VIII Lapulapu’s Pacific. Rye. Barrel 56. 106.6 proof"
  },
  {
    "category": "Rye",
    "name": "Wilderness Trail/ Single Barrel. Barrel Proof. Bottle 87/250. 105 proof"
  },
  {
    "category": "Rye",
    "name": "Willett Family Estate/ 4 yr.. Rare Release. Small Batch. 110 proof"
  },
  {
    "category": "Rye",
    "name": "Wolves in Collaboration with Willett Family Estate/ Batch No. 1. 103 proof"
  },
  {
    "category": "Rye",
    "name": "Wolves in Collaboration with Willett Family Estate/ Cask Strength. Batch No. 2 114.7 proof"
  },
  {
    "category": "Rye",
    "name": "Woodford Reserve/ Proprietary Batch. 90.4 proof"
  },
  {
    "category": "Wheated",
    "name": "1792/ Sweet Wheat. 91.2 proof"
  },
  {
    "category": "Wheated",
    "name": "Bernheim Original/ 7yr.. Small Batch. 90 proof"
  },
  {
    "category": "Wheated",
    "name": "Boone County/ Small Batch. Single Barrel. 7 yr.. 107.2 proof"
  },
  {
    "category": "Wheated",
    "name": "Buffalo Trace/ Kosher. 94 proof"
  },
  {
    "category": "Wheated",
    "name": "Casey Jones/ 3.3 yr.. Small Batch. 110 proof"
  },
  {
    "category": "Wheated",
    "name": "Heaven’s Door/ 11 yr.. The Bootleg Series. Vol. IV. Islay Scotch Cask. 2022. 111.16 Proof"
  },
  {
    "category": "Wheated",
    "name": "Larceny/ Small Batch. 92 proof"
  },
  {
    "category": "Wheated",
    "name": "Laws Whiskey House/ Centennial. Bonded. 5 yr.. Batch 3. 100 proof"
  },
  {
    "category": "Wheated",
    "name": "Lone Elm/ Small Batch Straight Wheat Whiskey. 90 proof"
  },
  {
    "category": "Wheated",
    "name": "Middle West/ Small Batch Craft. Michelone Reserve. OH. Batch 78. 95 proof"
  },
  {
    "category": "Wheated",
    "name": "Nine Bandit/ Austin.TX. Cask. 115 proof"
  },
  {
    "category": "Wheated",
    "name": "Ragged Branch/ BIB. Batch 2. Bottle 1673. VA. 100 proof"
  },
  {
    "category": "Wheated",
    "name": "Redemption/ Batch No. 6. 96 proof"
  },
  {
    "category": "Wheated",
    "name": "Reservoir/ 2021. Batch No. 6. Bottle 107. Virginia. 100 proof"
  },
  {
    "category": "Wheated",
    "name": "Smooth Ambler/ Big Level. 100 proofWeller/ 12 yr.. 90 proof"
  },
  {
    "category": "Wheated",
    "name": "Weller/ Antique 107. 107 proof"
  },
  {
    "category": "Wheated",
    "name": "Weller/ Full Proof. 114 proof"
  },
  {
    "category": "Wheated",
    "name": "Weller/ Single Barrel. 97 proof"
  },
  {
    "category": "Wheated",
    "name": "Whiskey Smith/ Small Batch. TX. 90 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Andalusia/ Single Malt. 100 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Andalusia/ Stryker. Smoked. TX. 100 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Balcones/ Pot Distilled. 106 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Balcones/ Single Barrel. ACL pick. 129.4 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Bruichladdich/ Islay Barley. 100 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Caol Ila/ 12 yr.. Islay. 86 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Highland Park/ Viking Heart. 15 yr.. 88 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Lagabvulin/ Distillers Edition. Islay. Batch 4/508. 86 proofc"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Lagabvulin/ Offerman Edition. 11 yr.. Charred Oak Cask. Islay. 92 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Laphroaig/ 10 year.. Sherry Oak. Islay. 96 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Laphroaig/ Cairdeas. Islay. Warehouse 1. 104.4 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Laphroaig/ Quarter Cask. Islay. 96 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Lismore/ The Legend. 21 yr.. 1800 Bottles. 86 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Ranger Creek/ 302. Smoked Single Malt. Finished in Wine Barrels."
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Ranger Creek/ 303. Smoked Single Malt. Finished in Sherry Barrels.  88 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Ranger Creek/ Rim Fire. Mesquite Smoked. TX. 86 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Stranahan’s/ Sherry Casks. Small Batch. Batch No. 010. 94 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "WestBland Garryana/ American Single Malt. Native Oak Series. Limited Release 2019 edition 4/1"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Westland American Oak/ American Single Malt. 92 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Westland Outpost Range Garryana/ 5th Edition.American Single Malt. 100 proof"
  },
  {
    "category": "Single Malt Whiskey",
    "name": "Westland/ Peated. American Single Malt. 92 proof"
  },
  {
    "category": "Corn",
    "name": "Balcones/ True Blue. Cask Strength. Single Barrel. Made from Roasted Blue Corn. ACL pick. 129 proof"
  },
  {
    "category": "Corn",
    "name": "Balcones/ TX. Baby Blue. Made from roasted blue corn. 92 proof"
  },
  {
    "category": "Corn",
    "name": "Balcones/ TX. Big Baby. BIB. Matured in Tequila Cask. 100 proof"
  },
  {
    "category": "Corn",
    "name": "Casey Jones/ Barrel Cut. Double Barrel. Small Batch. 105.3 proof"
  },
  {
    "category": "Corn",
    "name": "Casey Jones/ Barrel Cut. Single Barrel. Small Batch. 104.8 proof"
  },
  {
    "category": "Corn",
    "name": "Casey Jones/ Moonshine. Small Batch. Total Eclipse Lights Out. 100 proof"
  },
  {
    "category": "Corn",
    "name": "Flatt Valley/ 80 proof"
  },
  {
    "category": "Corn",
    "name": "High Wire/ New Southern Revival. 100% Jimmy Red Corn. 95 proof"
  },
  {
    "category": "Corn",
    "name": "ivy Mountain/ Appalachian. Batch 1. Bottle 643. 90 proof"
  },
  {
    "category": "Corn",
    "name": "Mellow Corn/ BIB. 100 proof"
  },
  {
    "category": "Corn",
    "name": "No. 9/ Small Batch. Slipnot. Iowa. 90 proof"
  },
  {
    "category": "Corn",
    "name": "Yellowrose/ Outlaw. TX. 92 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Buchanan’s Select/ Malt Perfection. 15 yr.. 80 proofBuchanan’s/ 12 yr.. 80 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Chivas Regal/ 12 yr.. 80 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Chivas Regal/ 18 yr.. 80 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Chivas Royal Salute/ 21 yr.. 80 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ Artist Blend. 86 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ Canvas. 92 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ EXPERIMENTAL Grain Whisky. 92 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ Flaming Heart. 97.8 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ Glasgow Blend. 98 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ Hedonism. 86 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ Juveniles. Limited Edition. 92 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ No Name. Limited Edition. 97.8 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ Oak Cross/ 86 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ Orchard House. 92 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ Rogue’s Banquet. Limited Edition. 92 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ The Circle. Limited Edition. Release No. 2. 92 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ The Peat Monster. 92 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ The Spaniard. 86 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Compass Box/ Ultramarine. The Extinct Blends Quartet. Limited Edition. 5430"
  },
  {
    "category": "Blended Scotch",
    "name": "Bottles. 102 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Dewar’s/ 12 yr.. 80 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Dewar’s/ 18 yr.. 80 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Johnnie Walker/ Blue Label. 80 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Johnnie Walker/ Gold Label. 18 yr.. 80 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Johnnie Walker/ Green Label. 15 yr.. 86 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Johnnie Walker/ High Rye. 90 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Monkey Shoulder/ Batch 27. 86 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Old Parr/ 18 yr.. 80 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Old Smuggler/ 80 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Scallywag/ Small Batch Release. 92 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Sneaky Peat/ No. 288. 86 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "The Famous Grouse/ 80 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Wemyss Malts/ Peat Chimney. Small Batch. 92 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Wemyss Malts/ Spice King. Small Batch. 92 proof"
  },
  {
    "category": "Blended Scotch",
    "name": "Wemyss Malts/ The Hive. Small Batch. 92 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Aberfeldy/ 12 yrs.. Highland. 80 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Aberlour/ A’Bunadh Alba. Speyside. Cask Strength. 117.4 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Ardbeg/ Islay. 10 yr.. 92 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Ardbeg/ Traigh Bhan. 19 yr.. Islay. Small Batch. 92.4 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Auchentoshan/ American Oak. 80 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Balblair/ 12 yr.. Highland. 92 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Bowmore/ 12 yr.. Islay. 80 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Bruichladdich/ Black Art. 1994. Edition 08.1. 26 yr.. Limited Edition."
  },
  {
    "category": "Single Malt Scotch",
    "name": "Unpeated. Islay. 90.2 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Bruichladdich/ The Classic Laddie. Islay. Unpeated. Scottish Barley. 100"
  },
  {
    "category": "Single Malt Scotch",
    "name": "proofBunnahabhain/ Cask Strength. 2021 Edition. 12 yr.. Islay. 110.2 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Bunnahabhain/ Islay. 12 yr.. Small Batch. 92.6 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Glenfidddich/ 12 yr.. 80 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Glenfiddich/ 18 yr.. Small Batch Reserve. Sherry Casks. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Glenfiddich/ 30yr.. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Glenfiddich/ Gran Reserva. 21 yr.. Rum Cask. 80 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Glengoyne/ 10 yr.. Highland. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Glenkinchie/ 12 yr.. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Glenmorandgie/ 18 yr.. Extremely Rare. Highland. Oak Casks. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Glenmorandgie/ Signet. Highland. 92 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Glenmorandgie/ The La Santa. 12 yr.. Highland. Sherry Casks. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Kilchoman/ Islay. Machir Bay. 92 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Lagavulin/ 16 yr.. Islay Single Malt. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Laphroaig/ 10 yr.. Islay. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Oban/ 14 yr.. Highland. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Octomore/ Islay. Edition 13.1. Super Heavily Peated. 108.4 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Old Pulteney/ 12 yr.. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "ORPHaN BARREL/ Muckety-Muck. 25 yr.. 91 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Port Charlotte/ Islay. 10 yr.. Heavily Peated. 100 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Spring Bank/ 10 yr.. 92 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Talisker/ 18 yr.. Isle of Skye. 91.6 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Arran/ 10 yr.. Isle of Arran. 92 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Balvenie/ 12 yr.. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Balvenie/ 14 yr.. Caribbean Cask. Rum Casks. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Balvenie/ 14 yr.. The Weak of Peat. 96.6 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Balvenie/ 15 yr.. Single Barrel. Sherry Cask. 95.6 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Balvenie/Caribbean Cask. 14 yr.. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Dalmore/ 18 yr.. Highland. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Dalmore/ Cigar Malt Reserve. Highland. 88 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Dalmore/ Port Wood Reserve. Highland. 93 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The GlenDronach/ Allardice. 18 yr.. Highland. Sherry Casks. 92 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The GlenDronach/ Original. 12 yr.. Highland. Sherry Casks. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Glenlivet/ 12 yr.. Double Oak. 80 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Glenlivet/ 18 yr.. Batch Reserve. 80 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Glenlivet/ 25 yr.. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Glenlivet/ Caribbean Reserve. 80 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Glenlivet/ Enigma. 121.2 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Macallan/ 12 yr.. Highland. Double Cask. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Macallan/ 12 yr.. Highland. Sherry Oak Cask. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Macallan/ 15 yr.. Double Cask. Highland. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Macallan/ 18 yr.. Highland. Sherry Oak Cask. 2021. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Macallan/ 18yr.. Double Cask. Highland. 2021. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Macallan/ 25 yr.. 2020. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Macallan/ Estate. Highland. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "The Macallan/ Rare Cask. Highland. 2020. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Tomatin/ 14 yr.. Port Cask. Highland. 92 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Tomatin/ 18 yr.. Oloroso Sherry Cask. Highland. 92 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Tomatin/ Highland. 12 yr.. Bourbon & Sherry Cask. 86 proof"
  },
  {
    "category": "Single Malt Scotch",
    "name": "Wolfburn/ Aurora. Sherry Oak. 92 proof"
  },
  {
    "category": "World Whisky",
    "name": "Akashi/ Japan. 80 proof"
  },
  {
    "category": "World Whisky",
    "name": "Akashi/ Ume. Plumed Flavor. Japan. 61 proof"
  },
  {
    "category": "World Whisky",
    "name": "Bastille/ 1789. Rare. French Limousine. Oak Cask. France. 80 proof"
  },
  {
    "category": "World Whisky",
    "name": "Chivalry/ French Whisky. Single Barrel. 80 proof"
  },
  {
    "category": "World Whisky",
    "name": "Fuyu/ Small Batch. Japan. 80 proof"
  },
  {
    "category": "World Whisky",
    "name": "Hatozaki/ Japan. 80 proof"
  },
  {
    "category": "World Whisky",
    "name": "Ichiro’s Malt & Grain/ Limited Edition. 96 proof"
  },
  {
    "category": "World Whisky",
    "name": "Ichiro’s Malt/ Chichibu. 2019. The U.S. Addition. Single Malt. Bottle"
  },
  {
    "category": "World Whisky",
    "name": "486/1556. Japan. 111 proof"
  },
  {
    "category": "World Whisky",
    "name": "Ichiro’s Malt/ Chichibu. Peated. The U.S. Addition. Single Malt. 2020. Japan."
  },
  {
    "category": "World Whisky",
    "name": "Bottle 784/2109. 111 proof"
  },
  {
    "category": "World Whisky",
    "name": "Ichiro’s Malt/ Chichibu. Single Malt. The U.S. Addition. 2021. Japan. Bottle"
  },
  {
    "category": "World Whisky",
    "name": "2024/2150. 107 proof"
  },
  {
    "category": "World Whisky",
    "name": "Ichiro’s Malt/ Double Distilleries. 2021. Chichibu x Komagatake. Chichibu"
  },
  {
    "category": "World Whisky",
    "name": "Aging. Bottle 9921/10200. Japan. 107 proof"
  },
  {
    "category": "World Whisky",
    "name": "Kamiki/ Maltage. Finished in Cedar Cask. 96 proof"
  },
  {
    "category": "World Whisky",
    "name": "Kavalan/ Classic. Taiwan. 86 proof"
  },
  {
    "category": "World Whisky",
    "name": "Kavalan/ Concertmaster. Port Cask Finished. Taiwan. 86 proof"
  },
  {
    "category": "World Whisky",
    "name": "Kikori/ Distilled from rice. Batch 4. Japan. 84 proof"
  },
  {
    "category": "World Whisky",
    "name": "Mars/ Iwai Tradition. Aki. Finished in Napa Wine Casks. 80 proof"
  },
  {
    "category": "World Whisky",
    "name": "Mars/ Iwai Tradition. Fuyu. Finished in Chest Nut Casks. 80 proof"
  },
  {
    "category": "World Whisky",
    "name": "Mars/ Iwai Tradition. Haru. Finished in Sakura Casks. 80 proof"
  },
  {
    "category": "World Whisky",
    "name": "Mars/ Iwai Tradition. Sherry Cask Finished. 80 proof"
  },
  {
    "category": "World Whisky",
    "name": "Mars/ Iwai. 45. 90 proof"
  },
  {
    "category": "World Whisky",
    "name": "Mars/ Iwai. 80 proof"
  },
  {
    "category": "World Whisky",
    "name": "Mars/ Komagatake. Single Malt. 2020. Tsunuki Aging. 108 proof"
  },
  {
    "category": "World Whisky",
    "name": "Mars/ Komagatake. Single Malt. 2020. Yakushima Aging. Japan. 106 proof"
  },
  {
    "category": "World Whisky",
    "name": "Mars/ Malt Duo. Komagatake x Chichibu. 2021. Shinshu Aging. Japan. 108 proof"
  },
  {
    "category": "World Whisky",
    "name": "Mars/ Single Malt. Komagatake. 2021. Japan. 96 proof"
  },
  {
    "category": "World Whisky",
    "name": "Mars/ Tradition. 80 proof"
  },
  {
    "category": "World Whisky",
    "name": "Nikka from the Barrel/ Japan. 102.8 proof"
  },
  {
    "category": "World Whisky",
    "name": "Nikka/ Coffey Grain. Japan. 90 proof"
  },
  {
    "category": "World Whisky",
    "name": "Nikka/ Taketsuru. Pure Malt. Japan. 86 proof"
  },
  {
    "category": "World Whisky",
    "name": "Reisetbauer & Son/ 15 yr.. Single Malt. Austria. 96 proof"
  },
  {
    "category": "World Whisky",
    "name": "Suntory/ The Yamazaki. Single Malt. 18 yr.. Japan. 86 proof"
  },
  {
    "category": "World Whisky",
    "name": "Suntory/ Toki. Blend. 86 proof"
  },
  {
    "category": "World Whisky",
    "name": "Suntory/The Hakushu. Single Malt. 12 yr.. Japan. 86 proof"
  },
  {
    "category": "World Whisky",
    "name": "The Shinobu/ Blended. Mizunara Oak. Japan. 86 proof"
  },
  {
    "category": "World Whisky",
    "name": "The Yamazaki/ Single Malt. 12 yr.. Japan. 86 proof"
  },
  {
    "category": "World Whisky",
    "name": "Yamato/ Small Batch. Mizunara. Japan. 80 proof"
  },
  {
    "category": "World Whisky",
    "name": "Yamato/ Special Edition. Cask Strength. Japan. 86 proof"
  },
  {
    "category": "Canadian Whisky",
    "name": "Alberta Premium/ Cask Strength Rye. Limited Edition. 127.4 proof"
  },
  {
    "category": "Canadian Whisky",
    "name": "Barrell/ 24 yr.. Bottle No. 4010. Finished in Oloroso Sherry and XO Armagnac"
  },
  {
    "category": "Canadian Whisky",
    "name": "Casks. 121.64"
  },
  {
    "category": "Canadian Whisky",
    "name": "Caribou Crossing/ Single Barrel. 80 proofCrown Apple/ 70 proof"
  },
  {
    "category": "Canadian Whisky",
    "name": "Crown Peach/ 70 proof"
  },
  {
    "category": "Canadian Whisky",
    "name": "Crown Royal/ 29 yr.. Extra Rare. 92 proof"
  },
  {
    "category": "Canadian Whisky",
    "name": "J.P. Wiser’s/ 15 yr.. 80 proof"
  },
  {
    "category": "Canadian Whisky",
    "name": "Johnnie Walker/ Johnnie Blonde. 80 proof"
  },
  {
    "category": "Canadian Whisky",
    "name": "Pendleton 1910/ Rye. 12 yr.. 80 proof"
  },
  {
    "category": "Canadian Whisky",
    "name": "Pendleton/ 80 proof"
  },
  {
    "category": "Canadian Whisky",
    "name": "Pendleton/ Directors’ Reserve. 20 yr.. 80 proof"
  },
  {
    "category": "Canadian Whisky",
    "name": "Pendleton/ Midnight. Brandy Barrel. 90 proof"
  },
  {
    "category": "Canadian Whisky",
    "name": "Rare Perfection/ 14 yr.. Lot No. 4. Over Proof. 110.7 proof"
  },
  {
    "category": "Canadian Whisky",
    "name": "Rare Perfection/ 15 yr.. Cask Strength. 119 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Blue Spot/ 7 yr.. Cask Strength. 117.8 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Bushmills/ 16 yr.. Single Malt. Rare. Oloroso Sherry and Port Pipe Finish."
  },
  {
    "category": "Irish Whiskey",
    "name": "80 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Glendalough/ Single Malt. 7 yr.. Mizunara Finished. Batch No. 1. 92 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Gold Spot/ 9 yr.. 135th Anniversary. Special Release. 102.8 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Green Spot/ 80 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Green Spot/ Chateau Leoville Barton. Bordeaux Wine Cask. 92 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Green Spot/ Chateau Montelena. Zinfandel Wine Cask. 92 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "High N’ Wicked/ Aeneas Coffey. Single Grain. Double Cask. 2022. 100 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Jameson Orange/ 60 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Jameson/ 18 yr.. 80 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Jameson/ 80 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Jameson/ IPA Edition. 80 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Knappogue Castle/ 16 yr.. Sherry Cask. 86 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Limavady/ Single Malt. Single Barrel. 92 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Middleton/ Very Rare. 2020. Vintage Release. Serial No. 06344. 80 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Middleton/ Very Rare. 2021. Vintage Release. Serial No. 19823. 80 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Red Spot/ 15 yr.. 92 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Redbreast/ 101 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Redbreast/ 12 yr.. 80 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Redbreast/ 21 yr.. 92 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Redbreast/ 27 yr.. Ruby Port Casks. 109.2 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Redbreast/ Lustau Edition. Sherry Finish. 92 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Redbreast/ PX Edition. PX Sherry Hogshead. 92 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Slane/ Triple Cask. Special Edition. The Legacy of ’81. 90 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "The Sexton/ Single Malt. The Walking Dead Edition. 80 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Tullamore Dew/ 80 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Writers Tears/ Copper Pot. Chapter 1. 80 proof"
  },
  {
    "category": "Irish Whiskey",
    "name": "Yellow Spot/ 12 yr.. 92 proof"
  },
  {
    "category": "Cognac",
    "name": "Courvoisier/ VSOP. 80 proof"
  },
  {
    "category": "Cognac",
    "name": "Crown Apple/ 70 proof"
  },
  {
    "category": "Cognac",
    "name": "Crown Peach/ 70 proof"
  },
  {
    "category": "Cognac",
    "name": "D’usse/ XO. 80 proof"
  },
  {
    "category": "Cognac",
    "name": "Devils River/ Agave Bourbon. 80 proof"
  },
  {
    "category": "Cognac",
    "name": "Fireball/ Cinnamon. 66 proof"
  },
  {
    "category": "Cognac",
    "name": "Glyph/ 85H. Not going to waste our time explaining this. 86 proof**"
  },
  {
    "category": "Cognac",
    "name": "Glyph/ Spice. Small Batch. Molecular Made. No Aging No Barrels. 86"
  },
  {
    "category": "Cognac",
    "name": "proof**"
  },
  {
    "category": "Cognac",
    "name": "Hennessy/ VSOP. Privilege. 80 proof"
  },
  {
    "category": "Cognac",
    "name": "Horned Hare Hareitic/ Habanero Orange. 60 proof"
  },
  {
    "category": "Cognac",
    "name": "Howler Head/ Banana. 80 proof"
  },
  {
    "category": "Cognac",
    "name": "Louis XIII/ 80 proof"
  },
  {
    "category": "Cognac",
    "name": "Martell/ VS. 80 proof"
  },
  {
    "category": "Cognac",
    "name": "Prichard’s/ Double Chocolate. 90 proof"
  },
  {
    "category": "Cognac",
    "name": "Remy Martin/ XO. 80 proof"
  },
  {
    "category": "Cognac",
    "name": "Root Out/ Rootbeer. 70 proof"
  },
  {
    "category": "Cognac",
    "name": "Skrewball/ Peanut Butter. 70 proof"
  },
  {
    "category": "Cognac",
    "name": "Soda Jerk/ Orange Cream"
  },
  {
    "category": "Cognac",
    "name": "Southern Comfort"
  },
  {
    "category": "Cognac",
    "name": "St. George/ Absinthe Verte. 120 proof"
  },
  {
    "category": "Cognac",
    "name": "Traverse City/ Small Batch. Traverse City Cherry Infused. 70 proof"
  },
  {
    "category": "Cognac",
    "name": "Wild Turkey/ American Honey. 71 proof"
  },
  {
    "category": "Rum",
    "name": "Appleton Estate/ Signature"
  },
  {
    "category": "Rum",
    "name": "Bacardi"
  },
  {
    "category": "Rum",
    "name": "Captain Morgan"
  },
  {
    "category": "Rum",
    "name": "Diplomatico/ PlanasGoslings/ Black Seal"
  },
  {
    "category": "Rum",
    "name": "Malibu"
  },
  {
    "category": "Rum",
    "name": "Meyers’s"
  },
  {
    "category": "Rum",
    "name": "Plantation/ 3 Stars"
  },
  {
    "category": "Rum",
    "name": "Pusser’s/ British Navy"
  },
  {
    "category": "Rum",
    "name": "Sailor Jerry"
  },
  {
    "category": "Rum",
    "name": "Amaro Averna Siciliano"
  },
  {
    "category": "Rum",
    "name": "Amaro Nonino"
  },
  {
    "category": "Rum",
    "name": "Ancho Reyes/ Chile Ancho/ Red"
  },
  {
    "category": "Rum",
    "name": "Aperol"
  },
  {
    "category": "Rum",
    "name": "Barenjager"
  },
  {
    "category": "Rum",
    "name": "Branca Menta"
  },
  {
    "category": "Rum",
    "name": "Campari"
  },
  {
    "category": "Rum",
    "name": "Chambord"
  },
  {
    "category": "Rum",
    "name": "Chartreuse/ Green"
  },
  {
    "category": "Rum",
    "name": "Chartreuse/ Yellow"
  },
  {
    "category": "Rum",
    "name": "Cointreau"
  },
  {
    "category": "Rum",
    "name": "Combier/ L’Original"
  },
  {
    "category": "Rum",
    "name": "Combier/ Peche de Vigne"
  },
  {
    "category": "Rum",
    "name": "Combier/ Rose"
  },
  {
    "category": "Rum",
    "name": "Crème de Violette"
  },
  {
    "category": "Rum",
    "name": "Cynar"
  },
  {
    "category": "Rum",
    "name": "D.O.M/ Benedictine"
  },
  {
    "category": "Rum",
    "name": "Disaronno"
  },
  {
    "category": "Rum",
    "name": "Dolce Cilento/ Limoncello"
  },
  {
    "category": "Rum",
    "name": "Drambuie"
  },
  {
    "category": "Rum",
    "name": "Fernet-Branca"
  },
  {
    "category": "Rum",
    "name": "Foro/ Originale"
  },
  {
    "category": "Rum",
    "name": "Frangelico"
  },
  {
    "category": "Rum",
    "name": "Grand Marnier"
  },
  {
    "category": "Rum",
    "name": "Grand Marnier/ Cuvee Louis-Alexandre"
  },
  {
    "category": "Rum",
    "name": "Greenbar/ Hibiscus"
  },
  {
    "category": "Rum",
    "name": "Heering/ Cherry"
  },
  {
    "category": "Rum",
    "name": "Jeppson’s/ Malort"
  },
  {
    "category": "Rum",
    "name": "Jeppson’s/ Malort. Barrel Aged"
  },
  {
    "category": "Rum",
    "name": "Kahlua"
  },
  {
    "category": "Rum",
    "name": "Licor/ 43"
  },
  {
    "category": "Rum",
    "name": "Mandarine Napoleon"
  },
  {
    "category": "Rum",
    "name": "Midori"
  },
  {
    "category": "Rum",
    "name": "Pimm’s/ No. 1"
  },
  {
    "category": "Rum",
    "name": "Romana Sambvca"
  },
  {
    "category": "Rum",
    "name": "St. Elder"
  },
  {
    "category": "Rum",
    "name": "St. George/ Nola Coffee"
  },
  {
    "category": "Rum",
    "name": "St. Germain"
  },
  {
    "category": "Rum",
    "name": "SuzeGin"
  },
  {
    "category": "Rum",
    "name": "Bombay Saphire"
  },
  {
    "category": "Rum",
    "name": "Empress/ 1908. Indigo Gin"
  },
  {
    "category": "Rum",
    "name": "Gray Whale"
  },
  {
    "category": "Rum",
    "name": "Gunpowder Irish Gin"
  },
  {
    "category": "Rum",
    "name": "Monkey 47"
  },
  {
    "category": "Rum",
    "name": "Plymouth Sloe Gin"
  },
  {
    "category": "Rum",
    "name": "Tanqueray"
  },
  {
    "category": "Tequila",
    "name": "Codigo/ 1530"
  },
  {
    "category": "Tequila",
    "name": "Corazon/ Expresiones. Aged 26 months. William Larue Weller Barrels."
  },
  {
    "category": "Tequila",
    "name": "Don Julio / Anejo"
  },
  {
    "category": "Tequila",
    "name": "Don Julio"
  },
  {
    "category": "Tequila",
    "name": "Don Julio/ 1942"
  },
  {
    "category": "Tequila",
    "name": "Dos Artes"
  },
  {
    "category": "Tequila",
    "name": "Fortaleza"
  },
  {
    "category": "Tequila",
    "name": "Anejo Cristalino"
  },
  {
    "category": "Tequila",
    "name": "1800"
  },
  {
    "category": "Tequila",
    "name": "Don Julio 70"
  },
  {
    "category": "Tequila",
    "name": "Komos"
  },
  {
    "category": "Tequila",
    "name": "Jose Cuervo/ Reserva De La FamiliaLobos/ PX Barrel Cask"
  },
  {
    "category": "Tequila",
    "name": "Tears of Horona/ No. 3"
  },
  {
    "category": "Tequila",
    "name": "Mezcal"
  },
  {
    "category": "Tequila",
    "name": "Clase Azul"
  },
  {
    "category": "Tequila",
    "name": "Del Maguey/ Vida"
  },
  {
    "category": "Tequila",
    "name": "Ilegal/ Joven"
  },
  {
    "category": "Tequila",
    "name": "Casamigos"
  },
  {
    "category": "Tequila",
    "name": "Corazon/ Expresiones. Aged 12 months. Elmer T. Lee Barrels. Barrel 3. Bottle 26"
  },
  {
    "category": "Tequila",
    "name": "Don Julio/ 1942. Primavera. Orange Wine Cask"
  },
  {
    "category": "Tequila",
    "name": "Maestro Dobel/ Diamante"
  },
  {
    "category": "Tequila",
    "name": "Teremana/ Small Batch"
  },
  {
    "category": "Tequila",
    "name": "Dos Artes/ Limited Edition. 80 proof"
  },
  {
    "category": "Tequila",
    "name": "Clase Azul Plata"
  },
  {
    "category": "Tequila",
    "name": "Espolon"
  },
  {
    "category": "Tequila",
    "name": "Fuenteseca/ Cosecha. 2018"
  },
  {
    "category": "Tequila",
    "name": "Lalo"
  },
  {
    "category": "Tequila",
    "name": "Crystal Head"
  },
  {
    "category": "Tequila",
    "name": "Deep Eddy/ Lemon"
  },
  {
    "category": "Tequila",
    "name": "Deep Eddy/ Peach"
  },
  {
    "category": "Tequila",
    "name": "Deep Eddy/ Ruby Red"
  },
  {
    "category": "Tequila",
    "name": "Effin Cucumber"
  },
  {
    "category": "Tequila",
    "name": "Grey Goose"
  },
  {
    "category": "Tequila",
    "name": "Ketel One"
  },
  {
    "category": "Tequila",
    "name": "Three Olives/ Loopy"
  },
  {
    "category": "Tequila",
    "name": "Western Son/ Cucumber"
  },
  {
    "category": "Extra",
    "name": "Bahnbrecker/ TX. Slow River Blend. Hefeweizen. 80 proof"
  },
  {
    "category": "Extra",
    "name": "Balcones/ TX. Rumble. A Texas Wildflower Honey. 94 proof"
  },
  {
    "category": "Extra",
    "name": "Bonnie Rose/ Spiced Apple. Corn White Whiskey. 70 proof"
  },
  {
    "category": "Extra",
    "name": "Brown Sugar BourbonBuffalo Trace/ Bourbon Cream"
  },
  {
    "category": "Extra",
    "name": "Buffalo Trace/ White Dog. Mash No. 1. 125 proof"
  },
  {
    "category": "Extra",
    "name": "Cobrafire/ Eau De Vie De Raisin. 104.6 proof"
  },
  {
    "category": "Extra",
    "name": "Ransom/ Whipper Snapper. Oregon Spirit Whiskey. 84 proof"
  },
  {
    "category": "Whiskey",
    "name": "RD One/ Small Batch, Finished with Brazillian Amburana Wood"
  },
  {
    "category": "Whiskey",
    "name": "RD One/ Finished with French Oak, 101 proof"
  },
  {
    "category": "Whiskey",
    "name": "RD One/ Double Finished in Oak and Maple Barrels, 99.9 proof"
  },
  {
    "category": "Whiskey",
    "name": "Buzzard’s ROOST/ Barrel Strength, 115.5 proof"
  },
  {
    "category": "Whiskey",
    "name": "Buzzard’s ROOST/ Toasted American Oak, 105 proof"
  },
  {
    "category": "Whiskey",
    "name": "Buzzard’s ROOST/ Char #1, 105 proof"
  },
  {
    "category": "Whiskey",
    "name": "Traveller Whiskey/ Blend No 40, 90 proof"
  },
  {
    "category": "Whiskey",
    "name": "Big Stick/ Finished on Oak Staves, 95 proof"
  },
  {
    "category": "Whiskey",
    "name": "Milam & Greene/ Very Small Batch, Finished with Charred French Oak Staves, 108 proof"
  },
  {
    "category": "Whiskey",
    "name": "Four Roses/ 9 yr. 4 mo., Single Barrel, ACL pick, 125.4 proof"
  },
  {
    "category": "Whiskey",
    "name": "Garrison Brothers/ Guadalupe, 2023, TX, Bottle No 2363 107 proof"
  },
  {
    "category": "Whiskey",
    "name": "Remus/ Gatsby Reserve, 15 yr., 2023 Limited Edition Release, Cask Strength, 98.1 proof"
  },
  {
    "category": "Rye",
    "name": "Buzzard’s ROOST/ Straight Rye, Barrel Strength, Batch 6, Bottle 451, 115.7 proof"
  },
  {
    "category": "Rye",
    "name": "Buzzard’s ROOST/ Straight Rye, Char #1 Rye, 105 proof"
  },
  {
    "category": "Rye",
    "name": "Buzzard’s ROOST/ Straight Rye, Toasted Barrel, Bottle 1353, Batch 3, 105 proof"
  },
  {
    "category": "Rye",
    "name": "Doc Swinson’s/ Alter Ego, Solera Method, Small Batch, Finished in Rum Casks, Release No. 21-009"
  },
  {
    "category": "Rye",
    "name": "High West/ A Midwinter Night’s Dram, Limited Engagement, Act 1.1, Scene 9, Port Barrel Finished"
  },
  {
    "category": "World Whisky",
    "name": "Akashi/ 4 yr., Single Malt Whisky, Ume Cask, 100 proof"
  }
];
